import { render } from "./ContractDocument.vue?vue&type=template&id=656ba22d&scoped=true"
import script from "./ContractDocument.vue?vue&type=script&lang=js"
export * from "./ContractDocument.vue?vue&type=script&lang=js"

import "./ContractDocument.vue?vue&type=style&index=0&id=656ba22d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656ba22d"]])

export default __exports__